import { useTranslation } from 'react-i18next';

export const useTexts = () => {
  const { t: i18nT, i18n } = useTranslation();

  const t = (category: string, key: string, options?: Record<string, unknown>): string => {
    return String(i18nT(`${category}.${key}`, options as any));
  };

  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return {
    t,
    language: i18n.language,
    setLanguage,
    loading: false, // i18next handles loading differently, usually not needed if bundled
    error: null
  };
};

